module.exports = __webpack_public_path__ + "img/corehcs.09a37572.svg";